import type { IconData } from '@stacksjs/iconify-core'

export const interfaceEssentialAlertTriangle2: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M30.48 24.38h-1.53v-3.05h-1.52v-3.04H25.9v-3.05h-1.52v-3.05h-1.52V9.14h-1.53V6.09h-1.52V3.05h-1.52V1.52h-1.53V0h-1.52v1.52h-1.53v1.53h-1.52v3.04h-1.52v3.05H9.14v3.05H7.62v3.05H6.09v3.05H4.57v3.04H3.05v3.05H1.52v3.05H0v3.05h1.52V32h28.96v-1.52H32v-3.05h-1.52Zm-10.67 3.05h-1.52v1.52h-4.58v-1.52h-1.52v-4.57h1.52v-1.53h4.58v1.53h1.52Zm0-10.67h-1.52v3.05h-4.58v-3.05h-1.52v-6.09h1.52V9.14h4.58v1.53h1.52Z\"/><path fill=\"currentColor\" d=\"M16.76 12.19h1.53v3.05h-1.53Zm-1.52-1.52h1.52v1.52h-1.52Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default interfaceEssentialAlertTriangle2
